module.exports = __webpack_public_path__ + "img/un-battant.7590993.svg";